module.exports = __webpack_public_path__ + "img/INPRG_ORANGE.3e4eff0f.svg";